import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Home, ChevronRight, Lock, LogIn, Loader2 } from "lucide-react";
import Header, { ARAC_TOOLS } from "../components/Header";
import Footer from "../components/Footer";
import MemberDialog from "../components/MemberDialog";
import { useMember } from "../context/MemberContext";
import WeatherTool from "../components/WeatherTool";
import AgendaTool from "../components/AgendaTool";
import BudgetTool from "../components/BudgetTool";
import SeatingTool from "../components/SeatingTool";
import GuestListTool from "../components/GuestListTool";
import FavoritesTool from "../components/FavoritesTool";
import InvitationTool from "../components/InvitationTool";

const Araclar = () => {
  const [params, setParams] = useSearchParams();
  const { member, loading } = useMember();
  const [dlg, setDlg] = useState(false);
  const tool = ARAC_TOOLS.find((t) => t.key === params.get("arac")) || ARAC_TOOLS[0];
  const active = tool.key;
  const Icon = tool.icon;

  return (
    <div className="min-h-screen bg-[#FBF5F0]" data-testid="araclar-page">
      <Header />
      <div className="max-w-7xl mx-auto px-5 pt-28 pb-6">
        <nav className="flex items-center gap-1.5 text-sm text-[#7C6E70]">
          <Link to="/" className="flex items-center gap-1 hover:text-[#9E2A3B]"><Home className="w-3.5 h-3.5" /> Anasayfa</Link>
          <ChevronRight className="w-3.5 h-3.5" />
          <span className="text-[#2A2224] font-medium">Araçlar</span>
          <ChevronRight className="w-3.5 h-3.5" />
          <span className="text-[#9E2A3B] font-medium">{tool.label}</span>
        </nav>
      </div>

      {loading ? (
        <div className="max-w-7xl mx-auto px-5 pb-32 flex justify-center pt-16">
          <Loader2 className="w-8 h-8 animate-spin text-[#9E2A3B]" />
        </div>
      ) : !member ? (
        <div className="max-w-lg mx-auto px-5 pb-32" data-testid="araclar-login-gate">
          <div className="bg-white rounded-2xl border border-[#F0DDE0] p-10 text-center">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#C15B6B] to-[#9E2A3B] flex items-center justify-center mx-auto mb-5">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <h1 className="font-display text-2xl font-bold text-[#2A2224]">Araçlar üyelere özeldir</h1>
            <p className="text-[#7C6E70] mt-3 max-w-sm mx-auto">
              Ajanda, bütçe, oturma planı, davetli listesi ve diğer düğün araçlarını kullanmak için ücretsiz üye girişi yapın.
            </p>
            <button
              onClick={() => setDlg(true)}
              data-testid="araclar-login-btn"
              className="mt-6 inline-flex items-center gap-2 px-7 py-3 rounded-full bg-gradient-to-r from-[#C15B6B] to-[#9E2A3B] text-white text-sm font-medium hover:shadow-lg transition-all"
            >
              <LogIn className="w-4 h-4" /> Üye Ol / Üye Girişi
            </button>
          </div>
          <MemberDialog open={dlg} onOpenChange={setDlg} />
        </div>
      ) : (
      <div className="max-w-7xl mx-auto px-5 pb-24 grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-6">
        <aside className="flex lg:flex-col gap-2 overflow-x-auto">
          {ARAC_TOOLS.map((t) => {
            const I = t.icon;
            const on = t.key === active;
            return (
              <button key={t.key} onClick={() => setParams({ arac: t.key })} data-testid={`arac-tab-${t.key}`}
                className={`flex items-center gap-2.5 shrink-0 px-4 py-3 rounded-xl text-sm font-medium text-left transition-all ${on ? "bg-[#9E2A3B] text-white shadow-sm" : "bg-white text-[#5b4d4f] hover:bg-[#FBF0F2] border border-[#F0DDE0]"}`}>
                <I className="w-4 h-4" /> {t.label}
              </button>
            );
          })}
        </aside>

        {active === "hava-durumu" ? (
          <WeatherTool />
        ) : active === "web-sitem" ? (
          <InvitationTool />
        ) : active === "ajandam" ? (
          <AgendaTool />
        ) : active === "butcem" ? (
          <BudgetTool />
        ) : active === "oturma-plani" ? (
          <SeatingTool />
        ) : active === "davetli-listem" ? (
          <GuestListTool />
        ) : active === "favorilerim" ? (
          <FavoritesTool />
        ) : (
          <div className="bg-white rounded-2xl border border-[#F0DDE0] py-20 px-6 text-center" data-testid={`arac-content-${active}`}>
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#C15B6B] to-[#9E2A3B] flex items-center justify-center mx-auto mb-5">
              <Icon className="w-8 h-8 text-white" />
            </div>
            <h1 className="font-display text-3xl font-bold text-[#2A2224]">{tool.label}</h1>
            <p className="text-[#7C6E70] mt-3 max-w-md mx-auto">{tool.desc}</p>
            <span className="inline-block mt-5 px-4 py-1.5 rounded-full bg-[#FBF3E4] text-[#8a6d1f] text-sm font-medium">Çok yakında</span>
          </div>
        )}
      </div>
      )}

      <Footer />
    </div>
  );
};

export default Araclar;
